(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  /* Cinta de frases: dirección, velocidad, reacción al scroll, pausa al pasar el mouse y dos cintas. */
  (function () {
    if (window.__kbCinta) return;
    window.__kbCinta = true;
    var bands = [], raf = 0, last = 0, sy = window.scrollY, vel = 0, dirScroll = 1, running = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function motionOn() {
      var f = document.documentElement.getAttribute('data-kb') || '';
      return !reduce && f.indexOf('motion') > -1;
    }

    function measure(b) {
      b.rows.forEach(function (r) {
        r.gw = r.group.getBoundingClientRect().width || r.gw || 1;
        var need = Math.ceil(b.el.getBoundingClientRect().width / r.gw) + 1;
        while (r.copies < need) {
          var c = r.group.cloneNode(true);
          c.removeAttribute('data-kb-group');
          c.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(c.querySelectorAll('a'), function (a) { a.tabIndex = -1; });
          r.track.appendChild(c);
          r.copies++;
        }
      });
    }

    function setup(el) {
      if (el.__kbCinta) return;
      el.__kbCinta = true;
      var b = {
        el: el, vis: true, hover: false, rate: 1, dir: 1,
        speed: parseFloat(el.getAttribute('data-speed')) || 60,
        mode: el.getAttribute('data-direction') || 'left',
        boost: el.getAttribute('data-boost') === 'true',
        skew: el.getAttribute('data-skew') === 'true',
        pause: el.getAttribute('data-pause') === 'true',
        sk: 0, rows: []
      };
      if (b.mode === 'right') b.dir = -1;
      Array.prototype.forEach.call(el.querySelectorAll('[data-kb-row]'), function (row) {
        var track = row.querySelector('[data-kb-track]'), group = row.querySelector('[data-kb-group]');
        if (!track || !group) return;
        b.rows.push({ row: row, track: track, group: group, mult: parseFloat(row.getAttribute('data-mult')) || 1, gw: 1, x: 0, copies: 1 });
      });
      if (!b.rows.length) return;
      if (!motionOn()) return;
      measure(b);
      b.rows.forEach(function (r) { if (r.mult < 0) r.x = -r.gw / 2; });
      if (b.pause) {
        el.addEventListener('mouseenter', function () { b.hover = true; });
        el.addEventListener('mouseleave', function () { b.hover = false; });
      }
      if ('IntersectionObserver' in window) {
        new window.IntersectionObserver(function (es) { b.vis = es[0].isIntersecting; start(); }).observe(el);
      }
      bands.push(b);
      start();
    }

    function frame(now) {
      raf = window.requestAnimationFrame(frame);
      var dt = Math.min(64, now - last); last = now;
      var y = window.scrollY, dy = y - sy; sy = y;
      if (dy) dirScroll = dy > 0 ? 1 : -1;
      vel += (dy - vel) * 0.16;
      if (Math.abs(vel) < 0.04) vel = 0;
      var live = false;
      bands = bands.filter(function (b) { return b.el.isConnected; });
      bands.forEach(function (b) {
        if (!b.vis) return;
        live = true;
        var target = b.mode === 'scroll' ? dirScroll : (b.mode === 'right' ? -1 : 1);
        b.dir += (target - b.dir) * (1 - Math.exp(-dt * 0.0036));
        b.rate += ((b.hover ? 0 : 1) - b.rate) * (1 - Math.exp(-dt * 0.008));
        var v = (b.speed + (b.boost ? Math.abs(vel) * 16 : 0)) * b.dir * b.rate;
        var sk = b.skew ? Math.max(-9, Math.min(9, vel * -0.35)) : 0;
        b.sk += (sk - b.sk) * 0.15;
        b.rows.forEach(function (r) {
          r.x -= v * r.mult * dt / 1000;
          r.x = ((r.x % r.gw) + r.gw) % r.gw - r.gw;
          r.track.style.transform = 'translate3d(' + r.x.toFixed(1) + 'px,0,0)';
          if (b.skew) r.track.style.setProperty('--sk', b.sk.toFixed(2));
        });
      });
      if (!live || document.hidden) stop();
    }
    function start() {
      if (running || !bands.length) return;
      running = true; last = performance.now(); sy = window.scrollY;
      raf = window.requestAnimationFrame(frame);
    }
    function stop() { running = false; window.cancelAnimationFrame(raf); }

    function scan(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kb-cinta]'), setup);
    }
    window.addEventListener('resize', function () { bands.forEach(measure); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-faq"] && !Shopify.designMode) return;
  try {
    
  /* "Escribir una reseña": el botón del panel abre el formulario del widget de la app (Judge.me).
     Si el widget no carga, el botón queda oculto y no pasa nada. */
  (function () {
    function enhance(root) {
      if (root.__kbRev) return;
      root.__kbRev = true;
      var btn = root.querySelector('[data-kb-write-review]');
      if (!btn) return;
      var tries = 0;
      function link() { return root.querySelector('.jdgm-write-rev-link'); }
      function ready() {
        btn.hidden = false;
        root.classList.add('is-proxied');
      }
      var timer = window.setInterval(function () {
        tries++;
        if (link()) { window.clearInterval(timer); ready(); }
        else if (tries > 40) window.clearInterval(timer);
      }, 400);
      btn.addEventListener('click', function () {
        var native = link();
        if (!native) return;
        native.click();
        window.setTimeout(function () {
          var target = root.querySelector('.jdgm-form-wrapper') || root.querySelector('[data-kb-reviews-widget]');
          if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 250);
      });
    }
    function scan(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kb-reviews]'), enhance);
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement"] && !Shopify.designMode) return;
  try {
    
  /* Manifiesto: el agua que recorre la sección con el scroll (y, si se activa, el cielo a lo Van Gogh).
     Los dibujos viven en assets/kb-agua.js y assets/kb-manifiesto-render.js y se cargan solo cuando la
     sección se acerca a la pantalla. Con "reducir movimiento" activado todo queda quieto. */
  (function () {
    var loading = {};
    function load(src, ready) {
      if (!src) return;
      var rec = loading[src];
      if (rec && rec.done) { ready(); return; }
      if (rec) { rec.cbs.push(ready); return; }
      rec = loading[src] = { done: false, cbs: [ready] };
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { rec.done = true; rec.cbs.forEach(function (f) { f(); }); };
      document.head.appendChild(s);
    }

    function boot(root) {
      if (root.__kbVg) return;
      root.__kbVg = true;
      var section = root.closest('.kb-statement') || root;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var skyCanvas = root.querySelector('.kb-statement__sky');
      var waterCanvas = root.querySelector('.kb-statement__water');
      var visible = false, loaded = false, sky = null, water = null, cur = 0, t = 0, last = 0, raf = 0;

      function target() {
        var r = section.getBoundingClientRect(), vh = window.innerHeight || 1;
        return Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      }
      function frame(now) {
        raf = visible ? window.requestAnimationFrame(frame) : 0;
        var dt = last ? Math.min(0.1, Math.max(0, (now - last) / 1000)) : 0;
        last = now;
        t += dt;
        if (water) { cur += (target() - cur) * (1 - Math.exp(-dt * 7)); water.draw(cur, t); }
        if (sky) sky.draw(t);
      }
      function start() { if (!raf && !still) { last = 0; raf = window.requestAnimationFrame(frame); } }

      function initWater() {
        if (!waterCanvas || waterCanvas.hidden || !window.KBWater) return;
        water = window.KBWater(waterCanvas, { maxDpr: 1.5 });
        water.resize();
        cur = still ? 0.5 : target();
        water.draw(cur, 0);
      }
      function initSky() {
        if (!skyCanvas || !window.KBVG || !window.KB_VG || sky) return;
        sky = window.KBVG(skyCanvas, window.KB_VG, { maxDpr: 1.5, fps: 24, anchorY: 0.28, still: still });
        sky.resize();
        root.classList.add('is-on');
      }
      function loadAll() {
        if (loaded) return;
        loaded = true;
        load(root.getAttribute('data-water-src'), function () { initWater(); if (visible) start(); });
        if (skyCanvas) {
          document.addEventListener('kb:vg-data', function () { initSky(); if (visible) start(); });
          load(root.getAttribute('data-render-src'), function () {
            if (window.KB_VG) initSky();
            else load(root.getAttribute('data-src'), function () { initSky(); if (visible) start(); });
          });
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[es.length - 1].isIntersecting;
          if (visible) { loadAll(); start(); }
        }, { rootMargin: '300px 0px' }).observe(section);
      } else { visible = true; loadAll(); start(); }

      var rt = 0;
      function onResize() { window.clearTimeout(rt); rt = window.setTimeout(function () { if (water) { water.resize(); water.draw(cur, t); } if (sky) sky.resize(); }, 120); }
      if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(root); else window.addEventListener('resize', onResize);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { visible = false; } else { visible = true; start(); } });
      root.__kbStop = function () { visible = false; };
    }

    function scan(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kb-vg]'), boot); }
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-kb-vg]'), function (el) { if (el.__kbStop) el.__kbStop(); });
    });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
  })();

  } catch(e) { console.error(e); }
})();
})();
